<template>
    <div>

        <el-dialog :visible.sync="showmodal" title="Update Status" width="30%" @close="$emit('close-modal')">
            <div class="particulars-img-wrapper">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 col-lg-12 col-12">
                            <label for="" class="label">Current Status</label>
                            <input type="text" v-model="currentStatusRef" class="input" />
                        </div>
                        <div class="col-md-12 col-lg-12 col-12">
                            <label for="" class="label">Updated By</label>
                            <input type="text" v-model="updatedBy" class="input" />
                        </div>
                        <div class="col-md-12 col-lg-12 col-12">
                            <label for="" class="label">Date Last Updated</label>
                            <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3"
                                v-model="createdAT" />
                        </div>
                        <div class="col-md-12 col-lg-12 col-12">
                            <label for="" class="label">New status</label>
                            <el-select v-model="newStatus" placeholder="Select state">
                                <!-- <el-select v-model="statusobj.newstatus" placeholder="Select state"> -->
                                <el-option v-for="status in statusList" :key="status" :label="capitalize(status.name)"
                                    :value="status.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="button-wrapper">
                <button @click="$emit('close-modal')">Cancel</button>
                <base-button text="Update" :loading="loading" @click="updateStatus(selecetedDispatch[0])" />
            </div>
        </el-dialog>
    </div>
</template>
<script type="text/javascript">

export default {
    props: {
        showmodal: Boolean,
        dispatchId: String,
        currentStatus: String,
        lastUpdated: String,
        statuses: Array,
        selectedItem: {
            type: Object,
            required: false,
            default: null
        },
        selcetdDispatchDetail: {
            type: Array,
            required: false,
            default: null
        },
        selecetedDispatch: {
            type: Array,
            required: false,
            default: () => []
        },
        longHaulDispatchables: {
            type: Object

        }
    },
    data() {
        return {

            newStatus: "",
            loading: false,
            updatedBy: this.$store.getters.user.firstname + " " + this.$store.getters.user.lastname,
            statusList: [
                {
                    name: 'Pending',
                    value: 'pending',
                },
                {
                    name: 'Dispatched from Origin Terminal',
                    value: 'dispatched_from_origin_terminal',
                },
                {
                    name: 'In Transit to Destination Terminal',
                    value: 'in_transit_to_destination_terminal',
                },
                {
                    name: 'Arrived at Destination Terminal',
                    value: 'arrived_at_destination_terminal',
                },
                {
                    name: 'Handed off',
                    value: 'handed_off',
                },
                {
                    name: 'Dispatched for Delivery',
                    value: 'dispatched_for_delivery',
                },
                {
                    name: 'Out for Delivery',
                    value: 'out_for_delivery',
                },
                {
                    name: 'Delayed',
                    value: 'delayed',
                },
            ],
        }
    },

    watch: {
        showmodal() {}
    },
    computed: {
        createdAT(){
             return this.selectedItem?.createdAt || this.selectedItem?.dispatchedAt
        },
        lastUpdatedRef() {
            return this.lastUpdated || this.selectedItem?.createdAt
        },
        currentStatusRef() {
            return (this.selectedItem?.currentStatus || this.selectedItem?.dispatchStatus)
        },
        buttonClass() {
            return this.isFormValid
                ? 'opacity-100 cursor-pointer hover:scale-105'
                : 'opacity-50 cursor-not-allowed';
        },

        isFormValid() {
            return (
                this.newStatus
            );
        },
        payload() {
            return {
                dispatchStatus: this.newStatus,
                message: "",
                userId: this.$store.state.authentication.quantumUserId
            }
        }

    },
    methods: {
        capitalize(str) {
            if (!str || typeof str !== 'string') return ''
            return str.charAt(0).toUpperCase() + str.slice(1)
        },

        async updateStatus(val) {
            this.loading = true
            try {
                let response = await this.$_modifyDispatch(val || this.selectedItem?.id || this.selectedItem?.dispatchId, this.payload);

                if (response.data.success === true) {
                    this.$emit('refetch-dispatch')
                    this.$emit('close-modal')
                    this.generateToast("Status updated!", "success");
                }
            } catch (error) {
                this.handleError(error);
                this.updatingUser = false;
            } finally {
                this.loading = false
            }
        },

    },
}
</script>